module.exports = __webpack_public_path__ + "static/media/notes-content-copy.35e20583.svg";